import React from 'react';
import PropTypes from 'prop-types';

import { Typography } from '@sm/wds-react';

import './main-heading.scss';

export const DEFAULT_HEADING_TEXT = 'Choose a plan that works for you';

/**
 * @desc The main heading and subheading component
 * @param {string} headingText - The main heading.
 */
const MainHeading = ({ headingText }) => (
  <Typography variant="hero1" component="h1" className="sm-main-heading__hero-title wds-m-t-4 wds-p-t-4" align="center">
    {headingText}
  </Typography>
);

MainHeading.propTypes = {
  headingText: PropTypes.string,
};
MainHeading.defaultProps = {
  headingText: DEFAULT_HEADING_TEXT,
};

export default MainHeading;
